// extracted by mini-css-extract-plugin
module.exports = {"hit":"search_hit__tvtII","type_event":"search_type_event__aqM4i","dark":"search_dark__HT0ZG","type_contributor":"search_type_contributor__Z1N8S"};